<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Importar Sumas y Saldos</span>
  <button mat-icon-button (click)="close()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content style="padding:16px 24px;min-width:360px">

  <p style="font-size:13.5px;color:#374151;margin:0 0 16px;line-height:1.6">
    Selecciona la <strong>fecha</strong> con la que deseas que figuren los
    <strong>asientos contables</strong> generados a partir de este archivo.
  </p>

  <mat-form-field appearance="outline" style="width:100%">
    <mat-label>Selecciona una fecha</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" name="selectedDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <div style="border:2px dashed #e5e7eb;border-radius:8px;padding:20px;text-align:center;margin-top:8px">
    <label for="fileInput" style="display:flex;flex-direction:column;align-items:center;gap:8px;cursor:pointer;color:#6b7280">
      <mat-icon style="font-size:32px;width:32px;height:32px;color:#9ca3af">cloud_upload</mat-icon>
      <span style="font-size:13.5px;font-weight:500">Selecciona un archivo Excel</span>
      <span style="font-size:12px;color:#9ca3af">.xlsx / .xls</span>
    </label>
    <input id="fileInput" type="file" accept=".xlsx, .xls" (change)="onFileSelected($event)"
           style="position:absolute;opacity:0;width:0;height:0">
    <p *ngIf="fileName" style="margin:8px 0 0;font-size:13px;font-weight:600;color:#0f172a">
      <mat-icon style="vertical-align:middle;font-size:16px">insert_drive_file</mat-icon>
      {{ fileName }}
    </p>
  </div>

  <div *ngIf="ready == false" style="display:flex;justify-content:center;padding:16px 0;gap:6px">
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="uploadFile()" [disabled]="!fileName || !selectedDate">
    <mat-icon>file_upload</mat-icon>
    Subir
  </button>
</mat-dialog-actions>
